var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"elder-modal"}},[(_vm.show)?_c('div',{staticClass:"elder-modal",on:{"mousedown":_vm.onClickaway,"touchstart":_vm.onClickaway}},[_vm._t("default",null,{"close":_vm.close})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }